import type { FC } from 'react';
import { PlusSquareOutlined } from '@ant-design/icons';
import { useTpoGenConfig } from '../../../context/CustomerConfigContext';
import { TPO_SCENARIO_COMPARISON_ADD_SLOT } from '../../../config/testIds';

interface EmptyScenarioSlotProps {
    kpiCount: number;
    onClick?: () => void;
}

const EmptyScenarioSlot: FC<EmptyScenarioSlotProps> = ({ kpiCount, onClick }) => {
    const { labels, scenarioComparisonConfig } = useTpoGenConfig();
    const { headerHeight, rowHeight, scenarioColumnMinWidth } = scenarioComparisonConfig.gridLayout;
    const totalHeight = headerHeight + kpiCount * rowHeight;

    return (
        <div className="flex flex-1 flex-col" style={{ minWidth: scenarioColumnMinWidth }}>
            <div
                className="relative border border-dashed border-black/20 rounded-lg cursor-pointer flex flex-col items-center justify-center"
                style={{ height: totalHeight }}
                onClick={onClick}
                data-testid={TPO_SCENARIO_COMPARISON_ADD_SLOT}
            >
                <div className="flex flex-col items-center gap-2">
                    <span className="p-2 rounded-full bg-[#F7F5FF] flex items-center justify-center">
                        <PlusSquareOutlined className="!text-[16px] !text-[#44338A]" />
                    </span>

                    <p className="text-[#44338A] text-sm text-center max-w-[203px] leading-[22px]">
                        {labels.comparisonReport.addScenarioPlaceholderHeader}
                    </p>
                    <p className="text-[#D9D9D9] text-sm text-center max-w-[203px] leading-[22px]">
                        {labels.comparisonReport.addScenarioPlaceholderDescription}
                    </p>
                </div>
            </div>
        </div>
    );
};

EmptyScenarioSlot.displayName = 'EmptyScenarioSlot';
export default EmptyScenarioSlot;
